var exports = {
  "UT": "MenuItems.module__roleIcon___TGRVWU",
  "yk": "MenuItems.module__roleContainer___TGRVWU",
  "S3": "MenuItems.module__roleName___TGRVWU",
  "nT": "MenuItems.module__roleDisabled___TGRVWU",
  "u8": "MenuItems.module__readonlyRoleItem___TGRVWU",
  "zQ": "MenuItems.module__readonlyRoleSpacer___TGRVWU",
  "ec": "MenuItems.module__flexColumn___TGRVWU",
  "Kk": "MenuItems.module__icon___TGRVWU",
  "Bx": "MenuItems.module__iconSmall___TGRVWU",
};

module.exports = exports;
